<!--
    描述：运营管理 -- 平台入驻企业
    时间：2020/9/24
    Created by zl
-->
<template>
  <div class="h100 settled-enterprises-layout">
    <!-- 列表查询页 -->
    <filter-layout
      @search="searchResult"
      @reset="resetForm"
      v-if="!routeQuery"
      hasMore
    >
      <template #filter>
        <el-form
          class="flex-row-form colspan-4"
          size="small"
          ref="searchRef"
          label-width="100px"
          :model="searchForm"
        >
          <el-form-item label="企业名称：" prop="sname">
            <el-input
              size="small"
              v-model="searchForm.sname"
              placeholder="请输入企业名称/信用代码"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="企业主：" prop="adminName">
            <el-input
              size="small"
              v-model="searchForm.adminName"
              placeholder="请输入姓名、手机号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="单位性质：" prop="companyType">
            <el-select v-model="searchForm.companyType" size="small" clearable>
              <el-option
                v-for="(item, index) in dwxz"
                :key="index"
                :label="item.sname"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="企业类型：" prop="mainType">
            <el-select v-model="searchForm.mainType" size="small" clearable>
              <el-option
                v-for="(item, index) in qyztlx"
                :key="index"
                :label="item.sname"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
      <template #more>
        <el-form
          class="flex-row-form colspan-4"
          size="small"
          ref="searchRef"
          label-width="100px"
          :model="searchForm"
        >
          <el-form-item label="入驻时间：" prop="dateArr" class="date-width">
            <el-date-picker
              v-model="searchForm.dateArr"
              type="daterange"
              clearable
              placeholder="请选择"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="endDatePicker"
            ></el-date-picker>
          </el-form-item>

        </el-form>
      </template>
      <template #content>
        <div class="content-header">
          <div class="title">
            合计入驻企业： <span class="blue">{{ qyTotal }}</span> 家
          </div>
          <div class="btnGroups">
            <el-button
              type="primary"
              class="btn-blue"
              size="mini"
              v-if="roleBtns.includes('add-tag')"
              @click="showTags('add')"
            >
              添加标签
            </el-button>
            <el-button
              type="primary"
              class="ml5 btn-blue"
              size="mini"
              @click="resetForm"
            >
              <i class="el-icon-refresh"></i>
            </el-button>
          </div>
        </div>
        <div class="operation-container w-table-layout w-table-page">
          <div class="w-table-content" v-show="tableShow">
            <el-table
              :data="tableObj.tableData"
              border
              ref="qyTable"
              highlight-current-row
              v-loading="tableObj.loading"
              @row-click="onRowClick"
              height="100%"
            >
              <el-table-column type="index" label="" width="50" align="center">
                <template slot-scope="scope">
                  <el-radio v-model="curRowId" :label="scope.row.id"></el-radio>
                </template>
              </el-table-column>
              <el-table-column
                type="index"
                label="序号"
                width="60"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <span class="text-right">
                    {{ parseInt(scope.$index) + 1 }}
                  </span>
                  <el-tooltip
                    :content="`标签：${scope.row.tags}`"
                    placement="right"
                    effect="light"
                    v-if="scope.row.tags && scope.row.tags !== ''"
                  >
                    <div slot="content" class="label-tooltip">
                      <el-tag
                        class="mr10 mb10"
                        size="mini"
                        v-for="(item, index) in toArray(scope.row.tags)"
                        :key="index"
                        >{{ item }}</el-tag
                      >
                    </div>
                    <svg-icon class="ml5" icon-class="biaoqian"></svg-icon>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                prop="sname"
                label="企业名称"
                min-width="255"
                header-align="center"
              ></el-table-column>
              <el-table-column
                prop="creditCode"
                label="统一社会信用代码"
                width="180"
                header-align="center"
              ></el-table-column>
              <el-table-column
                prop="companyTypeName"
                label="单位性质"
                width="135"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="mainTypeName"
                label="企业类型"
                width="135"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="adminName"
                label="企业主(姓名)"
                width="130"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="phone"
                label="手机号"
                width="130"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="createDate"
                label="企业入驻时间"
                width="165"
                align="center"
              ></el-table-column>
              <!--            <el-table-column
				  prop="isTrans"
				  label="是否平台转付"
				  width="105"
				  align="center"
				>
				  <template slot-scope="scope">
					{{ scope.row.isTrans == 1 ? "是" : "否" }}
				  </template>
				</el-table-column>-->
              <el-table-column
                prop="openSysNames"
                label="企业开通业务"
                min-width="230"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="ahCenter">
                    <!-- <el-tooltip effect="dark"
													content="企业已实名"
													placement="top">
											<svg-icon icon-class="company-rz"
													  class="icon width25 height25 blue"></svg-icon>
										</el-tooltip> -->
                    <el-tooltip
                      effect="dark"
                      :content="
                        scope.row.caStatus == 1 ? '已申请CA' : '未申请CA'
                      "
                      placement="top"
                    >
                      <svg-icon
                        icon-class="CA-rz"
                        class="icon"
                        :class="{ purple: scope.row.caStatus == 1 }"
                      ></svg-icon>
                    </el-tooltip>
                    <el-tooltip
                      effect="dark"
                      content="电子发票"
                      placement="top"
                    >
                      <svg-icon
                        icon-class="apply-invoice"
                        class="icon width25"
                        :class="{
                          'blue-invoice': scope.row.invoiceStatus == 1,
                        }"
                      ></svg-icon>
                    </el-tooltip>
                    <el-tooltip
                      effect="dark"
                      content="安招采电子招投标系统"
                      placement="top"
                    >
                      <svg-icon
                        :icon-class="
                          scope.row.aczStatus == 1
                            ? 'logo_anzhaocai'
                            : 'logo_anzhaocai_huise'
                        "
                        class="icon width25 height25"
                      ></svg-icon>
                    </el-tooltip>
                    <el-tooltip
                      effect="dark"
                      content="企业资金账户"
                      placement="top"
                    >
                      <svg-icon
                        icon-class="company-account"
                        class="icon"
                        :class="{ 'blue-invoice': scope.row.applyAccount == 1 }"
                      ></svg-icon>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="190">
                <template slot-scope="scope">
                  <!--                 <el-button
					  type="success"
					  size="small"
					  round
					  plain
					  class="table-btn"
					  @click="setPaySettings(scope.row)"
					  v-if="roleBtns.includes('company-detail')"
					>
					  <svg-icon icon-class="yy-system-management"></svg-icon>
					  支付设置
					</el-button>-->
                  <el-button
                    type="primary"
                    size="small"
                    round
                    plain
                    class="table-btn"
                    @click="viewMsg(scope.row)"
                    v-if="roleBtns.includes('company-detail')"
                  >
                    <svg-icon icon-class="form-details"></svg-icon> 详情
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="w-table-footer">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageForm.current"
              :page-sizes="[10, 20, 50]"
              :page-size="pageForm.pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageForm.total"
            >
            </el-pagination>
          </div>
        </div>
        <!-- 标签弹窗 -->
        <el-dialog
          :visible.sync="tagsDialog.visible"
          class="primary-dialog"
          :width="tagsDialog.width"
          :title="tagsDialog.title"
          :close-on-click-modal="false"
          @closed="handleClosed"
          center
        >
          <!-- 当前选择标签 -->
          <el-row>
            <el-col :span="4" class="text-right row-label"
              ><span>当前选择标签</span></el-col
            >
            <el-col :span="20" class="tags-container">
              <el-tag
                v-for="(item, index) in selectedTags"
                :key="'selectTag' + index"
                effect="dark"
                size="small"
                class="mr5"
                closable
                @close="onTagRemove(item)"
                >{{ item.sname }}</el-tag
              >
            </el-col>
          </el-row>

          <!-- 新增时的 输入框 -->
          <el-row class="mt5">
            <el-col :span="20">
              <el-input
                v-model="newTagName"
                placeholder="输入新的标签"
                :maxlength="15"
                show-word-limit
              ></el-input>
            </el-col>
            <el-col :span="4" class="text-right pdl10">
              <el-button class="btn-blue row-btn" @click="addNewTag"
                >保存</el-button
              >
            </el-col>
          </el-row>

          <!-- 全部标签 -->
          <div class="mt5 tags-all-container">
            <el-tag
              v-for="(item, index) in allTags"
              :key="'allTags' + index"
              :effect="item.isChoose === 1 ? 'dark' : 'plain'"
              class="mr5"
              size="small"
              @click="onTagSelected(item)"
              >{{ item.sname }}</el-tag
            >
          </div>
          <!-- footer 组件 -->
          <div slot="footer" class="dialog-footer text-center">
            <el-button
              class="btn"
              size="small"
              @click="tagsDialog.visible = false"
              >取 消</el-button
            >
            <el-button
              type="primary"
              size="small"
              class="btn btn-blue"
              :loading="btnLoading"
              @click="doTagsSave"
              >确 定</el-button
            >
          </div>
        </el-dialog>

        <!-- 支付设置弹窗 -->
        <el-dialog
          :visible.sync="payDialog.visible"
          class="primary-dialog"
          :width="payDialog.width"
          :title="payDialog.title"
          :close-on-click-modal="false"
          @closed="handlePayClosed"
          center
        >
          <div class="pay-setting">
            <div>
              是否开启平台转付：
              <el-switch
                class="switch"
                :active-value="1"
                active-text="是"
                :inactive-value="0"
                inactive-text="否"
                v-model="isTransPay"
              ></el-switch>
            </div>
            <div class="tips mt20 color-red">
              设置为平台转付后，投标人获取文件支付费用时将使用平台通联账户代付文件费、平台投标服务费等费用
            </div>
          </div>
          <!-- footer 组件 -->
          <div slot="footer" class="dialog-footer text-center">
            <el-button
              class="btn"
              size="small"
              @click="payDialog.visible = false"
              >取 消</el-button
            >
            <el-button
              type="primary"
              size="small"
              class="btn btn-blue"
              :loading="btnLoading"
              @click="doPaySave"
              >确 定</el-button
            >
          </div>
        </el-dialog>
      </template>
    </filter-layout>
    <div class="h100" v-else>
      <company-info></company-info>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

import {
	getObjectTags,
	getPlatFormTenants,
	saveObjectTags,
	updateTenantById,
} from "@/api/modules/enterprises_new";

import CompanyInfo from "./components/company-info";

export default {
  name: "Settled-enterprises",
  components: {
    CompanyInfo,
  },
  data() {
    return {
      searchForm: {
        sname: "",
        adminName: "",
        companyType: "",
        startDate: "",
        endDate: "",
        mainType: "",
      },
      pageForm: {
        current: 1, //当前页
        pagesize: 10, //每页条数
        total: 0, //总条数
      },
      tableObj: {
        loading: false,
        tableData: [], //表格数据数组
        height: 400,
      },
      qyTotal: 0,
      searchToggle: true,
      childId: "",
      companyObj: {
        adminName: "",
        phone: "",
        createDate: "",
        isReal: "",
        openSysNames: "",
      },
      tableShow: true,

      startDatePicker: this.beginDate(),
      endDatePicker: {
        disabledDate(time) {
          return time.getTime() > Date.now();

        },
      },
      // 标签相关
      btnLoading: false,
      curRowId: "",
      tagsDialog: {
        visible: false,
        width: "800px",
        title: "添加标签",
        type: "",
      },
      originalTags: [], // 初始选择的标签（做最后对比）
      selectedTags: [], // 当前选择标签
      publicTags: [], // 公共标签
      personalTags: [], // 个人历史标签
      allTags: [], // 所有标签（不再显示说明）
      newTagName: "", // 输入的标签名称
      objState: {
        caStatus: 0, // 申请Ca:
        invoiceStatus: 0, // 税务开票:
        aczStatus: 0, // 申请AZC:
        applyAccount: 0, // 账户:
      },
      // 支付设置弹窗
      payDialog: {
        visible: false,
        width: "600px",
        title: "支付设置",
      },
      isTransPay: 0, // 是否开通平台转付
    };
  },
  created() {
    // 如果是 返回的
    if (this.isBack) {
      if (this.$getSessionItem("searchForm")) {
        this.searchForm = JSON.parse(this.$getSessionItem("searchForm"));

        // 移除 避免污染
        this.$removeSessionItem("searchForm");
      }

      if (this.$getSessionItem("pageForm")) {
        this.pageForm = JSON.parse(this.$getSessionItem("pageForm"));

        // 移除 避免污染
        this.$removeSessionItem("pageForm");
      }
      if (this.$getSessionItem("objState")) {
        this.objState = JSON.parse(this.$getSessionItem("objState"));

        // 移除 避免污染
        this.$removeSessionItem("objState");
      }
    }

    this.getPlatFormTenants();
  },
  methods: {
    // 每页条数改变时
    handleSizeChange(pageSize) {
      this.pageForm.pagesize = pageSize;
      this.getPlatFormTenants();
    },

    // 当前页改变时
    handleCurrentChange(current) {
      this.pageForm.current = current;
      this.getPlatFormTenants();
    },

    // 获取所有入驻企业
    getPlatFormTenants() {
      this.tableObj.loading = true;
      if (this.searchForm.dateArr && this.searchForm.dateArr.length > 0) {
        this.searchForm.startDate = this.searchForm.dateArr[0] + " 00:00:00";
        this.searchForm.endDate = this.searchForm.dateArr[1] + " 23:59:59";
      } else {
        this.searchForm.startDate = "";
        this.searchForm.endDate = "";
      }
      console.log( this.searchForm)
      getPlatFormTenants({
        current: this.pageForm.current,
        size: this.pageForm.pagesize,
        sname: this.searchForm.sname,
        adminName: this.searchForm.adminName,
        companyType: this.searchForm.companyType,
        mainType: this.searchForm.mainType,
        startDate: this.searchForm.startDate,
        endDate: this.searchForm.endDate,
        // isReal: this.searchForm.isReal,
      })
        .then((d) => {
          this.pageForm.total = parseInt(d.data.pageData.total);
          this.tableObj.tableData = d.data.pageData.records;
          this.qyTotal = parseInt(d.data.totalCount);
          this.tableObj.loading = false;
        })
        .catch((err) => {
          this.tableObj.loading = false;
        });
    },

    // 搜索
    searchResult() {
      this.pageForm.pagesize = 10;
      this.pageForm.current = 1;
      this.getPlatFormTenants();
    },

    // 条件筛选重置
    resetForm() {
      this.pageForm.pagesize = 10;
      this.pageForm.current = 1;
      this.searchForm.sname = "";
      this.searchForm.adminName = "";
      this.searchForm.companyType = "";
      this.searchForm.mainType = "";
      this.searchForm.startDate = "";
      this.searchForm.endDate = "";
      this.searchForm.dateArr = []
      this.getPlatFormTenants();
    },

    // 查看公司详情
    viewMsg(data) {
      this.childId = data.id;
      // this.companyObj.adminName = data.adminName
      // this.companyObj.phone = data.phone
      // this.companyObj.createDate = data.createDate
      // this.companyObj.isReal = data.isReal
      // this.companyObj.openSysNames = data.openSysNames
      this.objState.caStatus = data.caStatus;
      this.objState.invoiceStatus = data.invoiceStatus;
      this.objState.aczStatus = data.aczStatus;
      this.objState.applyAccount = data.applyAccount;
      let searchForm = Object.assign({}, this.searchForm);
      let pageForm = Object.assign({}, this.pageForm);
      let objState = Object.assign({}, this.objState);
      // 存值
      this.$setSessionItem("searchForm", JSON.stringify(searchForm));
      this.$setSessionItem("pageForm", JSON.stringify(pageForm));
      this.$setSessionItem("objState", JSON.stringify(objState));

      this.$router.push({
        name: "Settled-enterprises-new",
        query: {
          type: "detail",
          tenantId: encodeURI(data.id),
        },
      });
    },

    // 查看详情页返回
    goBack() {
      this.$router.push({ path: "/settled-enterprises-new" });
    },

    // 设置支付设置
    setPaySettings(data) {
      this.curRowId = data.id;
      this.isTransPay = data.isTrans;
      this.payDialog.visible = true;
    },

    // 确定更改支付设置
    doPaySave() {
      this.btnLoading = true;
      let params = {
        id: this.curRowId,
        isTrans: this.isTransPay,
      };
      updateTenantById(params)
        .then((res) => {
          this.btnLoading = false;
          this.payDialog.visible = false;
          this.$message.success("设置成功！");

          // 重新获取数据
          this.getPlatFormTenants();
        })
        .catch((err) => {
          this.btnLoading = false;
          this.$message.error("设置失败！");
        });
    },

    // 是否展开搜索区域
    changeState() {
      this.searchToggle = !this.searchToggle;
    },

    // 开始时间的 pickOption
    beginDate() {
      let that = this;
      return {
        disabledDate(time) {
          let endTime = "";
          endTime = that.searchForm.endDate;
          if (endTime) {
            return bmElementTimeOptins.limitDateBefore(time, endTime, true);
          } else {
            return time.getTime() > Date.now();
          }
        },
      };
    },

    // 结束时间的 pickOption
    processDate() {
      let that = this;
      return {
        disabledDate(time) {
          let startTime = "";
          startTime = that.searchForm.startDate;
          if (startTime) {
            let nowTime = Date.now();
            return bmElementTimeOptins.limitDateInRange(
              time,
              startTime,
              nowTime,
              true
            );
          } else {
            return time.getTime() > Date.now();
          }
        },
      };
    },

    // --------------标签相关
    // 展示标签
    toArray(str) {
      // console.log(str.split(','))
      let arr = str.split(",").filter((x) => x !== "");
      return arr;
    },

    // 行点击事件
    onRowClick(row) {
      this.curRowId = row.id;
    },

    // 展示标签弹窗
    showTags(type) {
      if (this.curRowId === "") {
        this.$message.warning("请先选择要添加标签的企业！");
        return;
      }

      this.tagsDialog.visible = true;
      this.tagsDialog.type = type;
      switch (type) {
        case "add":
          // 新增
          let params = {
            objectId: this.curRowId,
            applys: "1001025001001",
            busUnit: "1001025001",
            createUserid: this.userInfo.id,
          };
          getObjectTags(params)
            .then((res) => {
              // 已选择标签
              this.originalTags = JSON.parse(
                JSON.stringify(res.data.privateExsitTags)
              );
              this.selectedTags = res.data.privateExsitTags;

              // 公共标签
              this.publicTags = res.data.platTags;

              // 个人历史标签
              this.personalTags = res.data.privateTags;

              // 所有标签集合
              this.allTags = [...res.data.platTags, ...res.data.privateTags];
            })
            .catch((err) => {});
          break;
        case "view":
          break;
      }
    },

    // 弹窗关闭
    handleClosed(needRefresh) {
      this.originalTags = [];
      this.selectedTags = [];
      this.publicTags = [];
      this.personalTags = [];

      this.tagsDialog.visible = false;
      this.tagsDialog.type = "";

      // 刷新
      needRefresh ? this.getPlatFormTenants() : "";
    },

    handlePayClosed() {
      this.payDialog.visible = false;
    },

    // 保存输入的标签
    addNewTag() {
      let value = this.newTagName.replace(/\s+/, "");
      if (value && value !== "") {
        // 再判断标签 是否已存在
        let _item = this.allTags.find((x) => x.sname === value);

        if (_item) {
          switch (_item.isChoose) {
            case 1:
              this.$message.info("该标签已选择！");
              break;
            default:
              _item.isChoose = 1;
              this.selectedTags.push(_item);
          }
        } else {
          let params = {
            id: "",
            tagId: "",
            sname: value,
            type: "0",
            isChoose: 1,
          };
          this.selectedTags.push(params);
        }

        this.newTagName = "";
      } else {
        this.$message.warning("请输入要保存的标签！");
      }
    },

    // 标签选择
    onTagSelected(item) {
      // console.log(item)
      // 选中状态
      item.isChoose = item.isChoose === 1 ? 0 : 1;

      // 选中标签数组
      if (item.isChoose === 1) {
        this.selectedTags.push(item);
      } else {
        let index = this.selectedTags.findIndex((x) => x.tagId === item.tagId);

        if (index > -1) {
          this.selectedTags.splice(index, 1);
        }
      }
    },

    // 选中标签删除
    onTagRemove(item) {
      // 如果不是 新增的标签
      if (item.tagId !== "") {
        let _index = this.allTags.findIndex((x) => x.tagId === item.tagId);
        if (_index > -1) {
          this.allTags[_index].isChoose = 0;
        }

        // // 如果是 公共标签
        // let _publicIndex = this.publicTags.findIndex((x) => x.id === item.id);
        // if (_publicIndex > -1) {
        //     this.publicTags[_publicIndex].isChoose = 0;
        // }

        // // 如果是 个人标签
        // let _personalIndex = this.personalTags.findIndex((x) => x.id === item.id);
        // if (_personalIndex > -1) {
        //     this.personalTags[_personalIndex].isChoose = 0;
        // }
      }

      // 选中数组移除
      this.selectedTags.splice(this.selectedTags.indexOf(item), 1);
    },

    // 表格中点击标签图标
    handleTagClick(scope) {
      // this.tagsDialog.visible = true
      // this.tagsDialog.type = 'edit'
      // console.log(scope);
    },

    // 标签弹窗保存
    doTagsSave() {
      this.btnLoading = true;

      let params = {
        objectId: this.curRowId,
        objectName: this.curRowName,
        applys: "1001025001001",
        busUnit: "1001025001",
        createUserid: this.userInfo.id,
        createUser: this.userInfo.sname,
        addTags: this.selectedTags,
        deleteTags: [],
      };

      // 新增、删除标签数组处理
      this.originalTags.map((x) => {
        let _index = this.selectedTags.findIndex((y) => y.id === x.id);
        if (_index > -1) {
          params.addTags.splice(_index, 1);
        } else {
          params.deleteTags.push(x);
        }
      });
      // params.addTags = this.selectedTags.filter(x => !x.id || x.id === '')
      // console.log(params.addTags)

      if (params.addTags.length === 0 && params.deleteTags.length === 0) {
        this.$message.warning("请操作后保存！");
        setTimeout(() => {
          this.btnLoading = false;
        }, 2000);
        return;
      }

      // 执行保存接口
      saveObjectTags(params)
        .then((res) => {
          if (res.operationCode === 1) {
            this.$message.success("保存成功!");
            setTimeout(() => {
              this.btnLoading = false;
              this.handleClosed(true);
            }, 2000);
          }
        })
        .catch((err) => {
          setTimeout(() => {
            this.btnLoading = false;
          }, 2000);
        });
    },
  },
  computed: {
    ...mapState("app", {
      clientSize: (state) => state.clientSize,
      isBack: (state) => state.isBack,
    }),
    ...mapState("dict", {
      dwxz: (state) => state.dwxz, // 单位性质
      qyztlx: (state) => state.qyztlx, // 企业主体类型
    }),

    ...mapState("user", {
      userInfo: (state) => state.userInfo,
    }),
    routeQuery() {
      return this.$route.query.type;
    },
    ...mapState("menu", {
      roleBtns: (state) => state.roleBtns,
    }),

    // 当前选择的 企业名称
    curRowName() {
      if (this.curRowId === "") {
        return "";
      }

      let _item = this.tableObj.tableData.find((x) => x.id === this.curRowId);
      if (_item) {
        return _item.sname;
      }

      return "";
    },
  },
  watch: {
    // 监听 筛选元素的 切换展示 重新调整表格高度
    searchToggle() {
      this.tableShow = false;
      setTimeout(() => {
        this.tableShow = true;
      }, 50);
      setTimeout(() => {
        this.$refs.qyTable.doLayout();
      }, 1000);
    },
  },
};
</script>
<style lang="less" scoped>
.settled-enterprises-layout {
  /deep/ .search-form {
    .el-form-item {
      margin-bottom: 5px;
    }
  }
  .content-header {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    .title {
      padding-left: 10px;
      border-left: 4px solid #2671cc;
      font-size: 14px;
      color: #202020;
    }
    .blue {
      font-size: 18px;
      color: #2671cc;
    }
  }
  .settled-enterprises-head {
    padding: 10px 20px 0 20px;
    .breadcrumb-list {
      padding: 0 15px;
      border: 1px solid #ddd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }
    /deep/ .el-breadcrumb__item {
      height: 35px;
      line-height: 35px;
    }
    .el-icon-location {
      color: #009900;
      font-size: 18px;
    }
    .content-head {
      padding-bottom: 20px;
    }
    .right-align {
      text-align: right;
    }
  }
  .settled-enterprises-content {
    height: calc(100% - 50px);
    padding: 0 20px;
    .content {
      height: calc(100% - 220px);
    }
  }
  .qy-number {
    display: inline-block;
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    font-size: 14px;
    border-left: 3px solid #2671cc;
    .blue {
      color: #2671cc;
      font-size: 18px;
      margin-right: 5px;
    }
  }
  .search-from {
    margin-bottom: 10px;
    border-bottom: 1px solid #2671cc;
  }
  .red {
    color: red;
  }
  .view-msg {
    color: #2671cc;
    cursor: pointer;
  }
  .ml25 {
    margin-left: 25px;
  }
  .icon {
    width: 20px;
    height: 20px;
    margin-right: 20px;
    color: #ccc;
  }
  .blue {
    color: #2671cc;
  }
  .purple {
    color: #ae5da1;
  }
  .blue-invoice {
    color: #2671cc;
  }
  .width25 {
    width: 25px;
  }
  .height25 {
    height: 25px;
  }
}

.pd0 {
  padding: 0 !important;
}
.pd5 {
  padding: 0 5px;
}
</style>

<style lang="less" scoped>
.w-table-content {
  /deep/ .el-radio__label {
    display: none;
  }
}

.label-tooltip {
  max-width: 600px;
  max-height: 140px;
  overflow-y: auto;
  overflow-x: hidden;
}

.primary-dialog {
  /deep/ .el-dialog__body {
    padding: 30px;
  }

  .row-label {
    height: 40px;
    line-height: 40px;
    padding-right: 15px;
  }

  .row-btn {
    padding-left: 10px;
    width: 100%;
  }

  .tags-container {
    line-height: 40px;
    max-height: 120px;
    overflow-y: auto;

    /deep/ .el-tag {
      cursor: pointer;
    }
  }

  .tags-all-container {
    line-height: 30px;
    max-height: 300px;
    overflow-y: auto;

    /deep/ .el-tag {
      cursor: pointer;
    }
  }

  .switch /deep/ .el-switch__label--left span {
    margin-left: 40px;
  }
}
</style>
